import React from "react";
import { Card } from "antd";

const UserActivity = () => {
  return (
    <>
      <div>
        <Card className="sidebarCard">
          <div className="flex py-2 justify-between">
            <p className="text-sm">Following</p>
            <p>130</p>
          </div>
          <div className="flex py-2 justify-between">
            <p className="text-sm">Followers</p>
            <p>1340</p>
          </div>
          <div className="flex py-2 justify-between">
            <p className="text-sm">Blocked</p>
            <p>4</p>
          </div>
          <div className="mt-5">
            <a href="#">Suggested Users</a>
          </div>
        </Card>
      </div>
    </>
  );
};

export default UserActivity;
